import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 150 150">
    {props.children}
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m105.9 17.2 20.6 11.9-5.2 3.1-20.6-12 5.2-3z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M121.3 32.2V53l-20.7-12V20.2l20.7 12Z"
    />
    <path fill="#F4EEE6" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="M121.3 32.2V53l5.2-3V29l-5.2 3Z" />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m5.8 109.8 69-39.8 69.3 40-69 39.8-69.3-40Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.77 6.77"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m109.8 136.2 34.4-19.8-69.3-40-69 39.7 34.8 20"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m36.7.3 74.8 43.3-6.6 3.8L30.1 4.1 36.7.3z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m105 47.4-.1 75.6L30 79.6 30.1 4l74.8 43.3Z"
    />
    <path fill="#fff" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="m105 57-.1 66L30 79.6v-66L105 57Z" />
    <path
      fill="#FAF5EF"
      d="M98.2 60.3v2.6l-10.6-6.2v-2.6l10.6 6.2ZM47.9 31.4v3.7L35.6 28v-3.7L48 31.4Zm50.3 33.9v2.6l-10.6-6.2v-2.6l10.6 6.2Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M86 83.3c3.4 1.9 6 6.6 6 10.4 0 3.8-2.6 5.4-6 3.5l-.4-.4c-3.4-1.9-6-6.5-6-10.4 0-3.8 2.7-5.4 6-3.4l.5.3ZM65.9 43c3.3 1.9 6 6.5 6 10.4 0 3.8-2.7 5.3-6 3.4l-.6-.3c-3.3-1.9-6-6.6-6-10.4 0-3.8 2.7-5.4 6-3.5l.6.3Zm5 32.7v12.8l-11.6-6.7V69L71 75.7ZM51.6 65.1V78l-11.5-6.7V58.4l11.5 6.7Z"
    />
    <path
      fill="#FAF5EF"
      d="M51.5 81.5v2.4l-11.4-6.6v-2.5l11.4 6.7ZM70.8 92v2.5L59.3 88v-2.5L70.8 92ZM91 103.6v2.5l-11.4-6.6V97l11.4 6.6Z"
    />
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="M85.6 83v-6.2L46.2 54v7.8" />
    <path d="M34 11.7c.4.3.7 0 .7-.4s-.3-1.2-.8-1.4c-.5-.3-.8 0-.8.4s.3 1.2.8 1.4Zm3.2 1.9c.5.3.9 0 .9-.4s-.4-1.2-.9-1.4c-.4-.3-.8 0-.8.4s.4 1.2.8 1.4Zm3.4 1.9c.4.3.8 0 .8-.4s-.4-1.2-.8-1.4c-.5-.3-.8 0-.8.4s.3 1.2.8 1.4Z" />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m105 47.4-.1 75.6 6.6-3.9V43.6l-6.6 3.8Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m48.2 106.7 6.8 3.8-7.4 4.3-6.8-4 7.4-4.1Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m57.5 111.7 14.7 8.7-7.5 4.5-14.8-8.7 7.6-4.5Zm14.7 13.2 15.2 9M65.7 56.6v16.2m-35 36.9L11.5 98.5V78.3l19.2 11.4v20Z"
    />
  </svg>
);
